import { Action } from '@ngrx/store';
import { UrgencyModel } from './model';

export enum ActionTypes {
  FAILURE = '[Urgency] Failure',

  LOAD_REQUEST = '[Urgency] Load Request',
  LOAD_SUCCESS = '[Urgency] Load Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}
export class LoadRequestAction implements Action {
  readonly type = ActionTypes.LOAD_REQUEST;
}

export class LoadSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_SUCCESS;
  constructor(public items: UrgencyModel[]) {}
}

export type Actions = FailureAction | LoadRequestAction | LoadSuccessAction;
